
class CreditSerializer {
  static deSerialize(data) {
    return {
      document: data.Documento || '',
      date: data.Fecha,
      amount: data.ImporteTotal,
      number: data.Numero,
      plan: data.Plan,
      nextDue: data.ProximoVencimiento,
      balance: data.Saldo,
      lastPayment: data.UltimoPago,
      schemaPayments: data.VaCuotaDe,
    };
  }
}

export { CreditSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/CreditSerializer.js